import { Controller } from "@hotwired/stimulus"
import $ from "jquery"

import "../../css/template/elements.css"


export default class extends Controller {
    connect() {
        $('#receiptLink').attr('href','receipt.html?' + usertoken);
        $('#mklLink').attr('href','mkl.html?' + usertoken);
        $('#guarantyLink').attr('href','guaranty.html?' + usertoken);
        $('#profileLink').attr('href','profile.html?' + usertoken);

    }
}